module.exports = "/_next/static/files/81d9b4df3463b2ba9792a167f6af4e78.png";